export { default } from './es/icons/CollapseFilled';